"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Snippets = _interopRequireDefault(require("./Snippets"));
const TagManager = {
  dataScript: function (dataLayer) {
    const script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },
  gtm: function (args) {
    const snippets = _Snippets.default.tags(args);
    const noScript = () => {
      const noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };
    const script = () => {
      const script = document.createElement('script');
      script.innerHTML = snippets.script;
      return script;
    };
    const dataScript = this.dataScript(snippets.dataLayerVar);
    return {
      noScript,
      script,
      dataScript
    };
  },
  initialize: function ({
    gtmId = '',
    events = {},
    dataLayer = {},
    dataLayerName = 'dataLayer',
    auth = '',
    preview = '',
    domain = 'www.googletagmanager.com'
  }) {
    const gtm = this.gtm({
      id: gtmId,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth,
      preview,
      domain
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  // @ts-ignore
  dataLayer: function ({
    dataLayer,
    dataLayerName = 'dataLayer'
  }) {
    // @ts-ignore
    if (window[dataLayerName]) return window[dataLayerName].push(dataLayer);
    const snippets = _Snippets.default.dataLayer(dataLayer, dataLayerName);
    const dataScript = this.dataScript(snippets);
    document.head.insertBefore(dataScript, document.head.childNodes[0]);
  }
};
var _default = exports.default = TagManager;